import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import AppRoutes from "./AppRoutes";
import AppSeoProvider from "./AppSeoProvider";

const App: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <AppSeoProvider />
        <Header />
        <main>
          <AppRoutes />
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
};

export default App;
